/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_AangepastInputs */

const nl_planning_vakanties_aangepast = /** @type {(inputs: Planning_Vakanties_AangepastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aangepast`)
};

/**

* @param {Planning_Vakanties_AangepastInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_aangepast = /** @type {((inputs?: Planning_Vakanties_AangepastInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_AangepastInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_aangepast(inputs)
});
export { planning_vakanties_aangepast as "planning.vakanties.aangepast" }